<template>
    <div  style="min-height: 100%;"></div>
</template>

<script>
export default {
    name: "CVSpacer"
}
</script>

<style scoped>

</style>